import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * PaymentEventsApi
 * Search and retrieve individual payment webhook events
 */
export const PaymentEventsApi = {
  /**
   * Search payment events with filters
   * @param {Object} filters
   * @param {string} [filters.correlationId] - Filter by correlation ID
   * @param {string} [filters.provider] - Filter by payment provider (STRIPE, PAYPAL, etc.)
   * @param {string} [filters.eventType] - Filter by event type
   * @param {string} [filters.startDate] - ISO timestamp start date
   * @param {string} [filters.endDate] - ISO timestamp end date
   * @param {number} [filters.page=0] - Page number (0-indexed)
   * @param {number} [filters.size=50] - Page size
   * @returns {Promise<Response>} fetch Response with paginated event list
   */
  searchEvents: async (filters = {}) => {
    const params = new URLSearchParams();
    const {
      correlationId,
      provider,
      eventType,
      startDate,
      endDate,
      page = 0,
      size = 50
    } = filters;

    if (correlationId) params.set('correlationId', correlationId);
    if (provider) params.set('provider', provider);
    if (eventType) params.set('eventType', eventType);
    if (startDate) params.set('startDate', typeof startDate === 'string' ? startDate : startDate.toISOString());
    if (endDate) params.set('endDate', typeof endDate === 'string' ? endDate : endDate.toISOString());
    if (page != null) params.set('page', page);
    if (size != null) params.set('size', size);

    const qs = params.toString();
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/search${qs ? `?${qs}` : ''}`,
      { method: 'GET' }
    );
  },

  /**
   * Get a single payment event by ID
   * @param {string} eventId - Payment event UUID
   * @returns {Promise<Response>} fetch Response with event details
   */
  getEvent: async (eventId) => {
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/${eventId}`,
      { method: 'GET' }
    );
  }
};

export default PaymentEventsApi;
